// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as V3Tutorial$LiteracyplanetTupperware from "./V3Tutorial.res.mjs";
import * as TupperwareLayoutSwitch$LiteracyplanetTupperware from "./TupperwareLayoutSwitch.res.mjs";
import * as V3StimulusWithImageAndAudio$LiteracyplanetTupperware from "./V3StimulusWithImageAndAudio.res.mjs";

function V3AdvancedLayout$TutorialWithAudio(props) {
  var children = props.children;
  var sources = props.sources;
  var hasWords = props.hasWords;
  if (TupperwareLayoutSwitch$LiteracyplanetTupperware.use() === "Pilot") {
    return React.createElement(V3Tutorial$LiteracyplanetTupperware.make, {
                hasWords: hasWords,
                sources: sources,
                children: children
              });
  } else {
    return React.createElement(V3Tutorial$LiteracyplanetTupperware.Skilful.make, {
                hasWords: hasWords,
                sources: sources,
                children: children
              });
  }
}

var TutorialWithAudio = {
  make: V3AdvancedLayout$TutorialWithAudio
};

function V3AdvancedLayout$StimulusWithImageAndAudio(props) {
  var children = props.children;
  if (TupperwareLayoutSwitch$LiteracyplanetTupperware.use() === "Pilot") {
    return React.createElement(V3StimulusWithImageAndAudio$LiteracyplanetTupperware.make, {
                sources: props.sources,
                children: children
              });
  } else {
    return children;
  }
}

var StimulusWithImageAndAudio = {
  make: V3AdvancedLayout$StimulusWithImageAndAudio
};

function V3AdvancedLayout(props) {
  var children = props.children;
  var sources = props.sources;
  var layoutKind = props.layoutKind;
  if (layoutKind === "StimulusWithImageAndAudio") {
    return React.createElement(V3AdvancedLayout$StimulusWithImageAndAudio, {
                sources: sources,
                children: children
              });
  } else if (layoutKind === "TutorialWithAudioAndWords") {
    return React.createElement(V3AdvancedLayout$TutorialWithAudio, {
                hasWords: true,
                sources: sources,
                children: children
              });
  } else if (layoutKind === "TutorialWithAudio") {
    return React.createElement(V3AdvancedLayout$TutorialWithAudio, {
                hasWords: false,
                sources: sources,
                children: children
              });
  } else {
    return children;
  }
}

var make = V3AdvancedLayout;

var $$default = V3AdvancedLayout;

export {
  TutorialWithAudio ,
  StimulusWithImageAndAudio ,
  make ,
  $$default as default,
}
/* react Not a pure module */
